export const time = {
  yearAgo: '%% s %% năm trước',
  yearsAgo: '%% s %% năm trước',
  monthAgo: '%% s %% tháng trước',
  monthsAgo: '%% s %% tháng trước',
  weekAgo: '%% s %% tuần trước',
  weeksAgo: '%% s %% tuần trước',
  dayAgo: '%% s %% ngày trước',
  daysAgo: '%% s %% ngày trước',
  hourAgo: '%% s %% giờ trước',
  hoursAgo: '%% s %% giờ trước',
  minuteAgo: '%% s %% phút trước',
  minutesAgo: '%% s %% phút trước',
  justNow: 'Vừa xong',
  now: 'Bây giờ',
} as const;
